// extracted by mini-css-extract-plugin
module.exports = {"container":"Counter_container__1xTAO","digital":"Counter_digital__5gQQ7"};